import gql from 'graphql-tag'

export function generate_CHECK_DUPLICATION(table) {
  return gql`
  query check_duplication_${table}($condition: ${table}_bool_exp!){
  ${table}(where: $condition){
    id
  }
}`
}
